import { render, staticRenderFns } from "./archivoCard.vue?vue&type=template&id=508c5ea4&scoped=true"
import script from "./archivoCard.vue?vue&type=script&lang=js"
export * from "./archivoCard.vue?vue&type=script&lang=js"
import style0 from "./archivoCard.vue?vue&type=style&index=0&id=508c5ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c5ea4",
  null
  
)

export default component.exports